







































import HomeHero from '@/views/Home/HomeHero.vue';
import PlaceList from '@/components/PlaceList.vue';
import { mapState } from 'vuex';
import Vue from 'vue';
import { api } from '@/services/api';
import HomeAbout from '@/views/Home/HomeAbout.vue';

export default Vue.extend({
    name: 'HomeView',
    components: {
        HomeAbout,
        HomeHero,
        PlaceList,
    },
    data() {
        return {
            places: [],
            showFab: false,
        };
    },
    computed: {
        ...mapState('auth', [
            'currentUser',
        ]),
    },
    mounted() {
        setTimeout(() => {
            this.showFab = true;
        }, 100);
    },
    created() {
        api.get('places/recently-reviewed')
            .then((response) => {
                this.places = response.places;
            })
            .catch((err) => {
                console.error(err);
            });
    },
});
